import { Link } from 'gatsby'

import type { Image } from './Carousel'
import { GalleryMovie } from '../../product/sections/GalleryImage/GalleryMovie'
import type { Video } from '../../product/sections/GalleryImage/types/gallery-image'

export function CarouselSlide({
  index,
  slideWidth,
  currentIndex,
  totalSlides,
  href,
  item,
  renderImage,
  handleClick,
  Flags,
  renderCustomContent,
}: {
  index: number
  slideWidth: number
  currentIndex: number
  totalSlides: number
  href?: string
  item: Image | Video
  renderImage: (item: Image) => JSX.Element
  handleClick: (
    slideIndex: number,
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => void
  Flags?: React.ComponentType
  renderCustomContent?: (item: Image | Video) => React.ReactNode
}) {
  const renderSlideContent = (
    contentItem: Image | Video,
    carouselIndex: number
  ) => {
    const flagsComponent = carouselIndex === 0 && Flags ? <Flags /> : null

    let mediaComponent

    if (renderCustomContent) {
      const customContent = renderCustomContent(contentItem)

      if (customContent) {
        mediaComponent = customContent
      } else {
        mediaComponent =
          'url' in contentItem ? (
            <GalleryMovie {...contentItem} />
          ) : (
            renderImage(contentItem)
          )
      }
    } else {
      mediaComponent =
        'url' in contentItem ? (
          <GalleryMovie {...contentItem} />
        ) : (
          renderImage(contentItem)
        )
    }

    return (
      <>
        {flagsComponent}
        {mediaComponent}
      </>
    )
  }

  const renderSlideWrapper = (
    contentItem: Image | Video,
    carouselIndex: number
  ) => {
    const hasLink = typeof href === 'string' && href.trim().startsWith('/')
    const isVideo = 'url' in contentItem && contentItem.url

    const content = renderSlideContent(contentItem, carouselIndex)

    if (isVideo) {
      return (
        <button
          onClick={(e) => handleClick(carouselIndex, e)}
          className="w-full h-full bg-transparent border-0 p-0"
        >
          {content}
        </button>
      )
    }

    if (hasLink) {
      return (
        <Link to={href} onClick={(e) => handleClick(carouselIndex, e)}>
          {content}
        </Link>
      )
    }

    return (
      <button
        className="w-full h-full"
        onClick={(e) => handleClick(carouselIndex, e)}
      >
        {content}
      </button>
    )
  }

  return (
    <li
      className="carousel-slide"
      key={index}
      tabIndex={currentIndex === index ? 0 : -1}
      aria-label={`Slide ${index + 1} de ${totalSlides}`}
      aria-roledescription="slide"
      style={{
        width: `${slideWidth}%`,
        minWidth: `${slideWidth}%`,
        height: '100%',
      }}
    >
      {renderSlideWrapper(item, index)}
    </li>
  )
}
